import React from "react";
import styled from "styled-components";
import { FiPhone, FiMail } from "react-icons/fi";
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTwitter } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  // Navigate to route
  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Scroll to section (works even from other pages)
  const handleScroll = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // If user is on another page, go home first
      navigate("/");
      setTimeout(() => {
        const target = document.getElementById(sectionId);
        target?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  return (
    <FooterWrapper>
      <FooterContainer>
        {/* LATEST NEWS / UPDATES */}
        <FooterColumn>
          <ColumnTitle>Latest Updates</ColumnTitle>
          <ColumnList>
            <li>New AI-Powered CRM Application Launched</li>
            <li>Cloud Migration Service Available for SMEs</li>
            <li>Upcoming Webinar on Digital Transformation</li>
            <li>New Office Opened in Bangalore</li>
            <li>Pragan Tech Recognized for UI/UX Excellence</li>
          </ColumnList>
        </FooterColumn>

        {/* DISCOVER */}
       <FooterColumn>
  <ColumnTitle>Discover</ColumnTitle>
  <NavList>
    <li onClick={() => handleNavigate("/")}>Home</li>
    {/* <li onClick={() => handleScroll("services")}>Our Services</li> */}
    <li onClick={() => handleNavigate("/projects")}>Projects</li>
    <li onClick={() => handleNavigate("/contact")}>Contact Us</li>
    <li onClick={() => handleNavigate("/aboutus")}>About Us</li>
       <li onClick={() => handleNavigate("/privacy")}>Privacy Policy</li>
  </NavList>
</FooterColumn>



        {/* CONTACT */}
        <FooterColumn>
          <ColumnTitle>Get in Touch</ColumnTitle>
          <ColumnList>
            <li>
              <FiPhone /> +91 8072487998
            </li>
            <li>
              <FiMail /> sales@pragantechsolutions.com
            </li>
            <li>Pragan Tech Solutions</li>
            <li>First floor, Joseph Complex, 1, Xavier's Colony, Tirunelveli, Tamil Nadu 627005, India</li>
          </ColumnList>
        </FooterColumn>

        {/* ACTION BUTTONS */}
        <ActionColumn>
          <ActionButton onClick={() => handleNavigate("/contact")}>
            I want to apply
            <span>Explore career opportunities</span>
          </ActionButton>
          <ActionButton onClick={() => handleNavigate("/contact")}>
            I want to hire
            <span>Find your perfect technology partner</span>
          </ActionButton>
          {/* SOCIAL ICONS */}
          <SocialBar>
            <SocialIcon href="#" aria-label="Facebook">
              <FaFacebookF />
            </SocialIcon>
            <SocialIcon href="#" aria-label="LinkedIn">
              <FaLinkedinIn />
            </SocialIcon>
            <SocialIcon href="#" aria-label="Instagram">
              <FaInstagram />
            </SocialIcon>
            <SocialIcon href="#" aria-label="Twitter">
              <FaTwitter />
            </SocialIcon>
          </SocialBar>
        </ActionColumn>
      </FooterContainer>

      <FooterBottom>
        <span>© {new Date().getFullYear()} Pragan Tech Solutions</span>
<FooterLink to="/privacy">Privacy Policy</FooterLink>
        <span>Web Design by Pragan Tech Solutions</span>
      </FooterBottom>
    </FooterWrapper>
  );
};

export default Footer;

/* STYLED COMPONENTS */

const FooterWrapper = styled.footer`
  background: #1c1c1c;
  color: #fff;
  padding: 60px 20px 40px;
`;
const FooterLink = styled(Link)`
  color: #777;
  text-decoration: none;
  transition: 0.3s ease;
  cursor: pointer;

  &:hover {
    color: #ff8a3d;
  }
`;


const FooterContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FooterColumn = styled.div``;

const ColumnTitle = styled.h4`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
  text-transform: uppercase;

  /* Gradient Text Logic */
  background: linear-gradient(45deg, #ff8a3d, #d55bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  
  /* Fallback for older browsers */
  color: #ff8a3d; 
  
  /* Optional: Ensuring the line below matches */
  position: relative;
  display: inline-block; /* Keeps the gradient/line tight to the text width */
  padding-bottom: 5px;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 100%;
    background: linear-gradient(45deg, #ff8a3d, #d55bff);
  }
`;

const ColumnList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 12px;
    font-size: 14px;
    color: #ccc;
    display: flex;
    align-items: center;

    svg {
      margin-right: 8px;
      color: #F9840A;
    }
  }
`;

const ActionColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ActionButton = styled.button`
 background: linear-gradient(45deg,#ff8a3d,#d55bff);
  color: #fff;
  border: none;
  padding: 18px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  text-align: left;

  span {
    display: block;
    font-size: 12px;
    color: #f0f4ff;
    margin-top: 4px;
  }

  &:hover {
    background: linear-gradient(45deg,#ff8a3d,#d55bff);
  }
`;

const FooterBottom = styled.div`
  margin-top: 50px;
  border-top: 1px solid #333;
  padding-top: 20px;
  text-align: center;
  font-size: 12px;
  color: #777;

  span {
    display: inline-block;
    margin: 0 12px;

    @media (max-width: 600px) {
      display: block;
      margin: 6px 0;
    }
  }
`;
const SocialBar = styled.div`
  display: flex;
  gap: 14px;
  margin-top: 10px;
`;

const SocialIcon = styled.a`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(45deg,#ff8a3d,#d55bff);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px) scale(1.05);
    box-shadow: 0 10px 20px rgba(213,91,255,0.4);
  }
`;
const NavList = styled(ColumnList)`
  li {
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
      color: #fff;
      transform: translateX(6px);
    }
  }
`;


